import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as DashboardIcon } from 'assets/icons/sidebar/dashboard.svg';
import { ReactComponent as WarehouseIcon } from 'assets/icons/sidebar/warehouse.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/header/settings.svg';
import { ReactComponent as UsersIcon } from 'assets/icons/sidebar/users.svg';
import { ReactComponent as ProductionIcon } from 'assets/icons/sidebar/production.svg';
import { ReactComponent as FgWarehouseIcon } from 'assets/icons/sidebar/fg_warehouse.svg';
import { ReactComponent as OrdersIcon } from 'assets/icons/sidebar/orders.svg';
import { ReactComponent as BomIcon } from 'assets/icons/sidebar/bom.svg';
import { ReactComponent as AnalyticsIcon } from 'assets/icons/sidebar/analytics.svg';

import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkPermission } from "helpers/helpers";


function Sidebar() {
	const { t } = useTranslation()
	const location = useLocation()

	const reduxAccount = useSelector(state => state.account)

	function getMenu() {
		var arr = [];

		if (reduxAccount.role === 'WAREHOUSE_RAW') {
			arr.push({
				url: "/warehouse-raw/dashboard",
				title: t("dashboard"),
				icon: <DashboardIcon />
			})
		}

		if (reduxAccount.role === 'WAREHOUSE_FINISHED') {
			arr.push({
				url: "/warehouse-finished/dashboard",
				title: t("dashboard"),
				icon: <DashboardIcon />
			})

			// return [

			// 	{
			// 		url: "/warehouse-finished/orders",
			// 		title: t("orders"),
			// 		icon: <OrdersIcon />
			// 	},
			// ];
		}
		if (reduxAccount.role === 'SALES') {
			arr.push({
				url: "/sales/dashboard",
				title: t("dashboard"),
				icon: <DashboardIcon />
			})

			// return [

			// 	{
			// 		url: "/sales/warehouse-fg",
			// 		title: t("fg_warehouse"),
			// 		icon: <FgWarehouseIcon />
			// 	},
			// 	{
			// 		url: "/sales/orders",
			// 		title: t("orders"),
			// 		icon: <OrdersIcon />
			// 	},
			// ];
		}
		if (reduxAccount.role === 'PRODUCTION') {
			arr.push({
				url: "/production/dashboard",
				title: t("dashboard"),
				icon: <DashboardIcon />
			})

			// return [
			// 	{
			// 		url: "/production/production",
			// 		title: t("production"),
			// 		icon: <ProductionIcon />
			// 	},
			// 	{
			// 		url: "/production/recipes",
			// 		title: t("bom"),
			// 		icon: <BomIcon />
			// 	},
			// ];
		}
		if (reduxAccount.role === 'TECHNOLOGIST') {
			arr.push({
				url: "/technologist/dashboard",
				title: t("dashboard"),
				icon: <DashboardIcon />
			})

			// return [
			// 	{
			// 		url: "/technologist/production",
			// 		title: t("production"),
			// 		icon: <ProductionIcon />
			// 	},
			// 	{
			// 		url: "/technologist/recipes",
			// 		title: t("bom"),
			// 		icon: <BomIcon />
			// 	},
			// ];
		}
		if (reduxAccount.role === 'MANAGEMENT') {
			arr.push({
				url: "/managment/dashboard",
				title: t("dashboard"),
				icon: <DashboardIcon />
			});
			arr.push({
				url: "/managment/analytics",
				title: t("analytics"),
				icon: <AnalyticsIcon />
			});
			arr.push({
				url: "/managment/users",
				title: t("users"),
				icon: <UsersIcon />
			});
			arr.push({
				url: "/settings",
				title: t("settings"),
				icon: <SettingsIcon />
			});

			// return [
			// {
			// 	url: "/managment/warehouse",
			// 	title: t("raw_material_warehouse"),
			// 	icon: <WarehouseIcon />
			// },
			// {
			// 	url: "/managment/production",
			// 	title: t("production"),
			// 	icon: <ProductionIcon />
			// },
			// {
			// 	url: "/managment/fg-warehouse",
			// 	title: t("fg_warehouse"),
			// 	icon: <FgWarehouseIcon />
			// },
			// {
			// 	url: "/managment/orders",
			// 	title: t("orders"),
			// 	icon: <OrdersIcon />
			// },
			// {
			// 	url: "/managment/recipes",
			// 	title: t("bom"),
			// 	icon: <BomIcon />
			// },

			// {
			// 	url: "/managment/users",
			// 	title: t("users"),
			// 	icon: <UsersIcon />
			// },
			// {
			// 	url: "/settings",
			// 	title: t("settings"),
			// 	icon: <SettingsIcon />
			// },
			// ];
		}

		if (checkPermission("inventory.raw.view")) {
			arr.push({
				url: "/warehouse-raw/warehouse",
				title: t("raw_material_warehouse"),
				icon: <WarehouseIcon />
			});
		}
		if (checkPermission("procurement.view")) {
			arr.push({
				url: "/procurement/dashboard",
				title: t("my_requests"),
				icon: <DashboardIcon />
			});
		}
		if (checkPermission("procurement.request.view")) {
			arr.push({
				url: "/warehouse-raw/my-requests",
				title: t("my_requests"),
				icon: <OrdersIcon />
			});
		}
		if (checkPermission("production.view")) {
			arr.push({
				url: "/production/production",
				title: t("production"),
				icon: <ProductionIcon />
			});
		}
		if (checkPermission("inventory.finished.view")) {
			arr.push({
				url: "/warehouse-finished/warehouse-fg",
				title: t("fg_warehouse"),
				icon: <FgWarehouseIcon />
			});
		}
		if (checkPermission("sales.order.view")) {
			arr.push({
				url: "/sales/orders",
				title: t("orders"),
				icon: <OrdersIcon />
			});
		}
		if (checkPermission("recipes.view")) {
			arr.push({
				url: "/technologist/recipes",
				title: t("bom"),
				icon: <BomIcon />
			});
		}
		if (checkPermission("recipes.boxes.view") && reduxAccount.role === 'TECHNOLOGIST') {
			arr.push({
				url: "/technologist/boxes",
				title: t("boxes"),
				icon: <WarehouseIcon />
			});
		}

		return arr;
	}

	useEffect(() => {
	}, [])

	return (
		<div className="sidebar">
			{getMenu().map((item, index) => (
				<Link to={item.url} className={`sidebar-item ${location.pathname.includes(item.url) ? 'active' : ''}`} key={index}>
					{item.icon}
					{item.title}
				</Link>
			))
			}
		</div>
	);
};

export default Sidebar